// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const mewtwo_mega_y: PokeData = {
  "id": 10044,
  "name": "mewtwo-mega-y",
  "height": 15,
  "weight": 330,
  "base_experience": 351,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "disable",
    "mist",
    "psybeam",
    "confusion",
    "psychic",
    "agility",
    "teleport",
    "recover",
    "confuse-ray",
    "barrier",
    "swift",
    "amnesia",
    "psywave",
    "safeguard",
    "psych-up",
    "future-sight",
    "calm-mind",
    "miracle-eye",
    "me-first",
    "power-swap",
    "guard-swap",
    "aura-sphere",
    "psycho-cut",
    "psystrike",
    "laser-focus"
  ],
  "moves": [
    "psychic",
    "confuse-ray",
    "psywave",
    "future-sight",
    "calm-mind",
    "healing-wish",
    "zen-headbutt",
    "psychic-fangs",
    "kinesis",
    "prismatic-cage",
    "reflect",
    "psy-ball",
    "psy-pulse"
  ],
  "evolution_chain": {
    "id": 77,
    "item": null,
    "species": [
      {
        "name": "mewtwo",
        "order": 182,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 101,
    "speed": 140,
    "ability_power": 194
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
